import { Controller } from '@hotwired/stimulus'
import { hideElement, showElement } from 'utils/toggle_element_visibility'

export default class extends Controller {
  static targets = ["upsellBanner"]

  toggleUpsell(event) {
    const reasonValue = event.target.value

    // CancellationReason.find(9) is the "I'm graduating" reason
    const graduatingValue = "9"

    if (reasonValue === graduatingValue) {
      showElement(this.upsellBannerTarget)
    } else {
      hideElement(this.upsellBannerTarget)
    }
  }
}
